var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.628,
    height: 13.628,
    viewBox: "0 0 13.628 13.628",
    style: {
      fontSize: 1
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m566.28 412.95-188.72-305.38c-15.207-24.551-39.918-24.605-55.125 0l-188.72 305.38c-20.406 32.969-5.582 59.551 33.039 59.551h366.52c38.551 0 53.375-26.637 33.023-59.551zm-216.28 7.0508c-9.6758 0-17.5-7.8242-17.5-17.5s7.8242-17.5 17.5-17.5 17.5 7.8242 17.5 17.5-7.8242 17.5-17.5 17.5zm17.5-87.449c0 9.5195-7.8242 17.449-17.5 17.449-9.7305 0-17.5-7.8242-17.5-17.449v-105.11c0-9.5195 7.8242-17.449 17.5-17.449 9.7305 0 17.5 7.8242 17.5 17.449z",
    transform: "translate(-60.829 -338.05)",
    fill: "#EE1B24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.f17098008287e0d82aa78b19dd924a80.svg";
export { ForwardRef as ReactComponent };